<template>
  <PerformsReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>

import _ from "underscore"
import Moment from "moment";
import Mapper from "@/mappers"
import {AllowPerformStatistics} from "@/enums/permission";
import ReportService from "@/services/report.service"
import {  LAYOUT_LOADING_START,  LAYOUT_LOADING_STOP,  LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PerformsReport from "@/components/report/DeliveryStatistics/PerformsReportComponent.vue";

export default {
  name: "PerformsReportView",
  components: {
    PerformsReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPerformStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, selectedFilters, selectedRegions, isAllClientsSelected, isArchive, clients} = filters;

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getPerformReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedRegions: selectedRegions ? selectedRegions : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                region: Mapper.mapRegion(rvm.Region),
                received: rvm.Received,
                successDelivered: rvm.SuccessDelivered,
                receiverDead: rvm.ReceiverDead,
                receiverNotLivesThere: rvm.ReceiverNotLivesThere,
                incompleteAddress: rvm.IncompleteAddress,
                receiverRefuse: rvm.ReceiverRefuse,
                notAtHome: rvm.NotAtHome,
                didntAppearOnNotice: rvm.DidntAppearOnNotice,
                defect: rvm.Defect,
                tryPerform: rvm.TryPerform,
                organizationWithGivenAddressNotFound: rvm.OrganizationWithGivenAddressNotFound,
                rest: rvm.Received - (rvm.SuccessDelivered + rvm.ReceiverDead +
                    rvm.ReceiverNotLivesThere + rvm.IncompleteAddress +
                    rvm.ReceiverRefuse + rvm.NotAtHome + rvm.DidntAppearOnNotice +
                    rvm.Defect + rvm.TryPerform + rvm.OrganizationWithGivenAddressNotFound)
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика о статусе")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
